/**
 * @generated SignedSource<<944ab033d358364c98adbb8b7acd6fe9>>
 * @relayHash 9016453eba0891823a6dfb1c8fe67c88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 492669a947b845a038686d616d81becd16d81c0de3cb05283123ea5d7eb3f75c

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type refetchIssue_IssueNavigatorQuery$variables = {
  amountOfColumns: number;
  cloudId: string;
  fieldSetIds: ReadonlyArray<string>;
  isConditionalFormattingEnabled: boolean;
  isTimelineEnabled: boolean;
  issueSearchInput: JiraIssueSearchInput;
};
export type refetchIssue_IssueNavigatorQuery$data = {
  readonly jira: {
    readonly issueSearchStable: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly fieldSetsById: {
            readonly " $fragmentSpreads": FragmentRefs<"IssueRow_fieldSets" | "main_issueNavigator_Card_fieldSets">;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type refetchIssue_IssueNavigatorQuery = {
  response: refetchIssue_IssueNavigatorQuery$data;
  variables: refetchIssue_IssueNavigatorQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isAtlasProjectEnabled_provider from '@atlassian/jira-relay-provider/src/atlas-project-native-integration.relayprovider';
import isPlaceholderDataEnabled_provider from '@atlassian/jira-relay-provider/src/goals-ssr-smart-card.relayprovider';
import isFieldsByIdRemoved_provider from '@atlassian/jira-relay-provider/src/issue-view-dfo-remove-fields-by-id.relayprovider';
import shouldShowHumanSupervisor_provider from '@atlassian/jira-relay-provider/src/jira-ai-show-human-supervisor-avatar.relayprovider';
import isJiraConfluencePageContentEnabled_provider from '@atlassian/jira-relay-provider/src/jira-confluence-page-content-enabled.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import originalEstimateEditableFixFlag_provider from '@atlassian/jira-relay-provider/src/jira-original-estimate-editable-fix.relayprovider';
import isNinStrikethroughResolutionUpdateEnabled_provider from '@atlassian/jira-relay-provider/src/nin-resolution-strikethough-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "amountOfColumns"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isConditionalFormattingEnabled"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTimelineEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v6 = {
  "kind": "Literal",
  "name": "first",
  "value": 1
},
v7 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  }
],
v8 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "amountOfColumns"
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "type"
},
v10 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v14 = {
  "kind": "ScalarField",
  "name": "name"
},
v15 = {
  "kind": "ScalarField",
  "name": "value"
},
v16 = [
  (v15/*: any*/),
  (v11/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "lazyIsEditableInIssueView"
},
v18 = {
  "kind": "ClientExtension",
  "selections": [
    (v17/*: any*/)
  ]
},
v19 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v20 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v21 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v22 = {
  "kind": "ScalarField",
  "name": "date"
},
v23 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "key"
},
v25 = {
  "kind": "ScalarField",
  "name": "text"
},
v26 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v27 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v11/*: any*/)
  ]
},
v28 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v11/*: any*/)
  ]
},
v29 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v30 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v31 = {
  "kind": "ScalarField",
  "name": "webUrl"
},
v32 = {
  "kind": "ScalarField",
  "name": "issueTypeId"
},
v33 = {
  "concreteType": "JiraIssueTypeHierarchyLevel",
  "kind": "LinkedField",
  "name": "hierarchy",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "level"
    }
  ]
},
v34 = {
  "concreteType": "JiraStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": [
    (v27/*: any*/),
    (v11/*: any*/)
  ]
},
v35 = {
  "kind": "ScalarField",
  "name": "picture"
},
v36 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v37 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v38 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v39 = {
  "concreteType": "JiraEstimate",
  "kind": "LinkedField",
  "name": "originalEstimate",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "timeInSeconds"
    }
  ]
},
v40 = {
  "concreteType": "JiraTimeTrackingSettings",
  "kind": "LinkedField",
  "name": "timeTrackingSettings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "workingHoursPerDay"
    },
    {
      "kind": "ScalarField",
      "name": "workingDaysPerWeek"
    },
    {
      "kind": "ScalarField",
      "name": "defaultFormat"
    },
    {
      "kind": "ScalarField",
      "name": "defaultUnit"
    }
  ]
},
v41 = {
  "kind": "ScalarField",
  "name": "versionId"
},
v42 = {
  "concreteType": "JiraIssue",
  "kind": "LinkedField",
  "name": "issue",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v43 = {
  "kind": "ScalarField",
  "name": "__id"
},
v44 = {
  "kind": "ClientExtension",
  "selections": [
    (v43/*: any*/)
  ]
},
v45 = {
  "kind": "ScalarField",
  "name": "href"
},
v46 = [
  {
    "kind": "Literal",
    "name": "viewId",
    "value": "list_default"
  }
],
v47 = [
  (v12/*: any*/),
  (v13/*: any*/),
  {
    "kind": "InlineFragment",
    "selections": [
      (v22/*: any*/)
    ],
    "type": "JiraDatePickerField"
  },
  (v11/*: any*/)
],
v48 = [
  (v12/*: any*/),
  (v11/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "refetchIssue_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearchStable",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v8/*: any*/),
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsById",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "isConditionalFormattingEnabled",
                                "variableName": "isConditionalFormattingEnabled"
                              },
                              {
                                "kind": "Literal",
                                "name": "isDensityFull",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "isEditableSyncLoaded",
                                "value": false
                              },
                              {
                                "kind": "Literal",
                                "name": "isInlineEditingEnabled",
                                "value": true
                              },
                              {
                                "kind": "Literal",
                                "name": "isLinkRelationshipFieldEnabled",
                                "value": false
                              },
                              {
                                "kind": "Variable",
                                "name": "isTimelineEnabled",
                                "variableName": "isTimelineEnabled"
                              }
                            ],
                            "kind": "FragmentSpread",
                            "name": "IssueRow_fieldSets"
                          },
                          {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fieldSets"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "refetchIssue_IssueNavigatorQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v7/*: any*/),
            "concreteType": "JiraIssueConnection",
            "kind": "LinkedField",
            "name": "issueSearchStable",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraIssueEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v8/*: any*/),
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsById",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "JiraIssueFieldSetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                  },
                                  {
                                    "concreteType": "JiraIssueFieldConnection",
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v11/*: any*/),
                                              (v12/*: any*/),
                                              (v13/*: any*/),
                                              (v9/*: any*/),
                                              {
                                                "kind": "TypeDiscriminator",
                                                "abstractKey": "__isJiraIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedServiceConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedAffectedServicesConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAffectedServiceEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAffectedService",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "serviceId"
                                                              },
                                                              (v14/*: any*/),
                                                              (v11/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraAffectedServicesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraCascadingOption",
                                                    "kind": "LinkedField",
                                                    "name": "cascadingOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "parentOptionValue",
                                                        "plural": false,
                                                        "selections": (v16/*: any*/)
                                                      },
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "childOptionValue",
                                                        "plural": false,
                                                        "selections": (v16/*: any*/)
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraCascadingSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObjectConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedCmdbObjectsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraCmdbObjectEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraCmdbObject",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "objectId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "label"
                                                              },
                                                              {
                                                                "concreteType": "JiraCmdbAvatar",
                                                                "kind": "LinkedField",
                                                                "name": "avatar",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "concreteType": "JiraCmdbMediaClientConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "mediaClientConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "clientId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "fileId"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaBaseUrl"
                                                                      },
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "mediaJwtToken"
                                                                      }
                                                                    ]
                                                                  },
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "url48"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "QueryError",
                                                        "kind": "LinkedField",
                                                        "name": "errors",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "message"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCMDBField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "args": (v19/*: any*/),
                                                    "concreteType": "JiraComponentConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedComponentsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponentEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponent",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v20/*: any*/),
                                                              (v21/*: any*/),
                                                              (v11/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraComponentsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v22/*: any*/),
                                                  (v14/*: any*/),
                                                  (v23/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraDatePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "dateTime"
                                                  },
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraDateTimePickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraEpic",
                                                    "kind": "LinkedField",
                                                    "name": "epic",
                                                    "plural": false,
                                                    "selections": [
                                                      (v24/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "summary"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "color"
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraEpicLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "renderedFieldHtml"
                                                  }
                                                ],
                                                "type": "JiraFallbackField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v25/*: any*/),
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraSingleLineTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatusCategory",
                                                    "kind": "LinkedField",
                                                    "name": "statusCategory",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v26/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusCategoryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "statusId"
                                                      },
                                                      (v27/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraStatusField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": (v19/*: any*/),
                                                    "concreteType": "JiraLabelConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedLabelsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v10/*: any*/),
                                                      {
                                                        "concreteType": "JiraLabelEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraLabel",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v14/*: any*/),
                                                              (v28/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedLabelsConnection(first:1000)"
                                                  },
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraLabelsField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "issueType",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "small"
                                                          }
                                                        ]
                                                      },
                                                      (v14/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraIssueTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "parentIssue",
                                                    "plural": false,
                                                    "selections": [
                                                      (v24/*: any*/),
                                                      {
                                                        "concreteType": "JiraColorField",
                                                        "kind": "LinkedField",
                                                        "name": "issueColorField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v28/*: any*/),
                                                          (v11/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraIssueTypeField",
                                                        "kind": "LinkedField",
                                                        "name": "issueTypeField",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                              (v29/*: any*/),
                                                              (v14/*: any*/),
                                                              (v11/*: any*/)
                                                            ]
                                                          },
                                                          (v11/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraSingleLineTextField",
                                                        "kind": "LinkedField",
                                                        "name": "summaryField",
                                                        "plural": false,
                                                        "selections": [
                                                          (v25/*: any*/),
                                                          (v11/*: any*/)
                                                        ]
                                                      },
                                                      (v11/*: any*/),
                                                      (v30/*: any*/),
                                                      (v31/*: any*/),
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": false,
                                                        "selections": [
                                                          {
                                                            "args": [
                                                              {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                  "issuetype",
                                                                  "project",
                                                                  "summary",
                                                                  "status"
                                                                ]
                                                              }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v12/*: any*/),
                                                                      (v11/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v13/*: any*/),
                                                                          (v25/*: any*/)
                                                                        ],
                                                                        "type": "JiraSingleLineTextField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v13/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v11/*: any*/),
                                                                              (v32/*: any*/),
                                                                              (v14/*: any*/),
                                                                              (v29/*: any*/),
                                                                              (v33/*: any*/)
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraIssueTypeField"
                                                                      },
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v13/*: any*/),
                                                                          {
                                                                            "concreteType": "JiraStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v11/*: any*/),
                                                                              {
                                                                                "concreteType": "JiraStatusCategory",
                                                                                "kind": "LinkedField",
                                                                                "name": "statusCategory",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                  (v11/*: any*/),
                                                                                  (v26/*: any*/)
                                                                                ]
                                                                              }
                                                                            ]
                                                                          }
                                                                        ],
                                                                        "type": "JiraStatusField"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"issuetype\",\"project\",\"summary\",\"status\"])"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider",
                                                        "kind": "Condition",
                                                        "passingValue": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v13/*: any*/),
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v32/*: any*/),
                                                                  (v33/*: any*/)
                                                                ]
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraSingleLineTextField",
                                                            "kind": "LinkedField",
                                                            "name": "summaryField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v13/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v13/*: any*/),
                                                              (v34/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraParentIssueField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "priority",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "iconUrl"
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  },
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraPriorityField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraProject",
                                                    "kind": "LinkedField",
                                                    "name": "project",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v24/*: any*/),
                                                      {
                                                        "concreteType": "JiraAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "large"
                                                          }
                                                        ]
                                                      },
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraProjectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraResolution",
                                                    "kind": "LinkedField",
                                                    "name": "resolution",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraResolutionField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprintConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedSprintsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSprintEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSprint",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "sprintId"
                                                              },
                                                              (v14/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "state"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "endDate"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v14/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraSprintField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "kind": "LinkedField",
                                                    "name": "user",
                                                    "plural": false,
                                                    "selections": [
                                                      (v12/*: any*/),
                                                      (v14/*: any*/),
                                                      (v35/*: any*/),
                                                      (v36/*: any*/),
                                                      (v11/*: any*/),
                                                      (v37/*: any*/),
                                                      {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                          {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "appType"
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "type": "AppUser"
                                                      }
                                                    ]
                                                  },
                                                  (v23/*: any*/),
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraRichText",
                                                    "kind": "LinkedField",
                                                    "name": "richText",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraADF",
                                                        "kind": "LinkedField",
                                                        "name": "adfValue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                            "kind": "LinkedField",
                                                            "name": "convertedPlainText",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "plainText"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraRichTextField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraServiceManagementRequestType",
                                                    "kind": "LinkedField",
                                                    "name": "requestType",
                                                    "plural": false,
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v29/*: any*/),
                                                      (v11/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraServiceManagementRequestTypeField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "args": [
                                                      (v6/*: any*/)
                                                    ],
                                                    "concreteType": "JiraIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "issueLinkConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      (v10/*: any*/),
                                                      {
                                                        "concreteType": "JiraIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "issue",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v31/*: any*/),
                                                                  (v24/*: any*/),
                                                                  {
                                                                    "args": [
                                                                      {
                                                                        "kind": "Literal",
                                                                        "name": "ids",
                                                                        "value": [
                                                                          "statusCategory"
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldsById",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "concreteType": "JiraIssueFieldEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                              (v12/*: any*/),
                                                                              {
                                                                                "kind": "InlineFragment",
                                                                                "selections": [
                                                                                  (v27/*: any*/)
                                                                                ],
                                                                                "type": "JiraStatusCategoryField"
                                                                              },
                                                                              (v11/*: any*/)
                                                                            ]
                                                                          }
                                                                        ]
                                                                      }
                                                                    ],
                                                                    "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                  },
                                                                  {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "isResolved"
                                                                      }
                                                                    ]
                                                                  },
                                                                  (v11/*: any*/)
                                                                ]
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "relationName"
                                                              },
                                                              (v11/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "issueLinkConnection(first:1)"
                                                  }
                                                ],
                                                "type": "JiraIssueLinkField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isStoryPointField"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "number"
                                                  },
                                                  (v14/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraNumberFieldFormatConfig",
                                                        "kind": "LinkedField",
                                                        "name": "formatConfig",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatStyle"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "formatUnit"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraNumberField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCommentSummary",
                                                    "kind": "LinkedField",
                                                    "name": "commentSummary",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "canAddComment"
                                                      },
                                                      (v10/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraCommentSummaryField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "uri"
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraUrlField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "fieldOption",
                                                    "plural": false,
                                                    "selections": [
                                                      (v15/*: any*/),
                                                      (v28/*: any*/),
                                                      (v11/*: any*/),
                                                      (v38/*: any*/)
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraSingleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v15/*: any*/),
                                                              (v38/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraOptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOptions",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOptionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraOption",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v15/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraCheckboxesField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraUserConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedUsersConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraUserEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v12/*: any*/),
                                                              (v37/*: any*/),
                                                              (v14/*: any*/),
                                                              (v35/*: any*/),
                                                              (v11/*: any*/),
                                                              (v36/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "email"
                                                                  }
                                                                ],
                                                                "type": "AtlassianAccountUser"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraMultipleSelectUserPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraTeamView",
                                                    "kind": "LinkedField",
                                                    "name": "selectedTeam",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedId"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "jiraSuppliedName"
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraTeamViewField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v39/*: any*/),
                                                              (v40/*: any*/),
                                                              (v13/*: any*/),
                                                              (v14/*: any*/),
                                                              (v9/*: any*/),
                                                              (v18/*: any*/)
                                                            ]
                                                          },
                                                          (v11/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraTimeTrackingField",
                                                            "kind": "LinkedField",
                                                            "name": "timeTrackingField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v39/*: any*/),
                                                              (v40/*: any*/),
                                                              (v11/*: any*/),
                                                              (v13/*: any*/),
                                                              (v14/*: any*/),
                                                              (v9/*: any*/)
                                                            ]
                                                          },
                                                          (v11/*: any*/)
                                                        ]
                                                      },
                                                      (v18/*: any*/)
                                                    ],
                                                    "type": "JiraOriginalTimeEstimateField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "selectedOption",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": "label",
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                      },
                                                      (v11/*: any*/),
                                                      (v20/*: any*/)
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraRadioSelectField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "args": (v19/*: any*/),
                                                    "concreteType": "JiraVersionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedVersionsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersionEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraVersion",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v14/*: any*/),
                                                              (v20/*: any*/),
                                                              (v21/*: any*/),
                                                              (v41/*: any*/)
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraMultipleVersionPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  (v42/*: any*/),
                                                  {
                                                    "args": (v19/*: any*/),
                                                    "concreteType": "JiraGoalConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGoals",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoalEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGoal",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v24/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  (v14/*: any*/),
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "status"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v44/*: any*/)
                                                    ],
                                                    "storageKey": "selectedGoals(first:1000)"
                                                  },
                                                  {
                                                    "kind": "ClientExtension",
                                                    "selections": [
                                                      (v43/*: any*/),
                                                      (v17/*: any*/)
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraGoalsField"
                                              },
                                              {
                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      (v14/*: any*/),
                                                      (v42/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isLinkEditable"
                                                      },
                                                      {
                                                        "concreteType": "JiraTownsquareProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          (v11/*: any*/),
                                                          {
                                                            "alias": "atlasProjectName",
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                          },
                                                          {
                                                            "alias": "atlasProjectKey",
                                                            "kind": "ScalarField",
                                                            "name": "key"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "privateProject"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "hasPermission"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "isWorkspaceActive"
                                                          }
                                                        ]
                                                      },
                                                      (v18/*: any*/)
                                                    ],
                                                    "type": "JiraTownsquareProjectField"
                                                  }
                                                ]
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "args": (v19/*: any*/),
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                    "kind": "LinkedField",
                                                    "name": "confluenceRemoteIssueLinks",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraConfluenceRemoteIssueLink",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v45/*: any*/),
                                                              {
                                                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                                                                "kind": "Condition",
                                                                "passingValue": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "pageContent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v12/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v45/*: any*/)
                                                                        ],
                                                                        "type": "JiraConfluencePageContentDetails"
                                                                      }
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      },
                                                      (v10/*: any*/)
                                                    ],
                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraConfluenceRemoteIssueLinksField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  (v14/*: any*/),
                                                  {
                                                    "concreteType": "JiraGroupConnection",
                                                    "kind": "LinkedField",
                                                    "name": "selectedGroupsConnection",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroupEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v11/*: any*/),
                                                              (v14/*: any*/),
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "groupId"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v18/*: any*/)
                                                ],
                                                "type": "JiraMultipleGroupPickerField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraFlag",
                                                    "kind": "LinkedField",
                                                    "name": "flag",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isFlagged"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraFlagField"
                                              },
                                              {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraWatch",
                                                    "kind": "LinkedField",
                                                    "name": "watch",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "count"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "isWatching"
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "type": "JiraWatchesField"
                                              },
                                              {
                                                "condition": "isTimelineEnabled",
                                                "kind": "Condition",
                                                "passingValue": true,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          (v11/*: any*/),
                                                          (v30/*: any*/),
                                                          {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v14/*: any*/),
                                                                  (v33/*: any*/),
                                                                  (v11/*: any*/)
                                                                ]
                                                              },
                                                              (v11/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraParentIssueField",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssueField",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssue",
                                                                "kind": "LinkedField",
                                                                "name": "parentIssue",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v30/*: any*/),
                                                                  (v24/*: any*/),
                                                                  (v11/*: any*/)
                                                                ]
                                                              },
                                                              (v11/*: any*/)
                                                            ]
                                                          },
                                                          (v24/*: any*/),
                                                          {
                                                            "concreteType": "JiraStatusField",
                                                            "kind": "LinkedField",
                                                            "name": "statusField",
                                                            "plural": false,
                                                            "selections": [
                                                              (v34/*: any*/),
                                                              (v11/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                            "kind": "LinkedField",
                                                            "name": "assigneeField",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                  (v12/*: any*/),
                                                                  (v35/*: any*/),
                                                                  (v11/*: any*/)
                                                                ]
                                                              },
                                                              (v11/*: any*/)
                                                            ]
                                                          },
                                                          {
                                                            "args": (v46/*: any*/),
                                                            "kind": "LinkedField",
                                                            "name": "startDateViewField",
                                                            "plural": false,
                                                            "selections": (v47/*: any*/),
                                                            "storageKey": "startDateViewField(viewId:\"list_default\")"
                                                          },
                                                          {
                                                            "args": (v46/*: any*/),
                                                            "kind": "LinkedField",
                                                            "name": "endDateViewField",
                                                            "plural": false,
                                                            "selections": (v47/*: any*/),
                                                            "storageKey": "endDateViewField(viewId:\"list_default\")"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraTimelineField"
                                                  }
                                                ]
                                              },
                                              (v44/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "condition": "isConditionalFormattingEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldSetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraIssueFieldSet",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "JiraIssueFieldConnection",
                                        "kind": "LinkedField",
                                        "name": "fields",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueFieldEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "args": (v19/*: any*/),
                                                        "concreteType": "JiraComponentConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedComponentsConnection",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraComponentEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraComponent",
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                  {
                                                                    "kind": "ScalarField",
                                                                    "name": "componentId"
                                                                  }
                                                                ]
                                                              }
                                                            ]
                                                          }
                                                        ],
                                                        "storageKey": "selectedComponentsConnection(first:1000)"
                                                      }
                                                    ],
                                                    "type": "JiraComponentsField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "priorityId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraPriorityField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraProject",
                                                        "kind": "LinkedField",
                                                        "name": "project",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "projectId"
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraProjectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "version",
                                                        "plural": false,
                                                        "selections": [
                                                          (v41/*: any*/),
                                                          (v11/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraSingleVersionPickerField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueType",
                                                        "kind": "LinkedField",
                                                        "name": "issueType",
                                                        "plural": false,
                                                        "selections": [
                                                          (v32/*: any*/)
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "selectedValue",
                                                        "plural": false,
                                                        "selections": (v48/*: any*/)
                                                      }
                                                    ],
                                                    "type": "JiraSingleSelectField"
                                                  },
                                                  {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraSelectableValueConnection",
                                                        "kind": "LinkedField",
                                                        "name": "selectedValues",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraSelectableValueEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                              {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": (v48/*: any*/)
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "type": "JiraMultipleSelectField"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v11/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "492669a947b845a038686d616d81becd16d81c0de3cb05283123ea5d7eb3f75c",
    "metadata": {},
    "name": "refetchIssue_IssueNavigatorQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcatlasprojectnativeintegrationrelayprovider": isAtlasProjectEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraoriginalestimateeditablefixrelayprovider": originalEstimateEditableFixFlag_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissueviewdforemovefieldsbyidrelayprovider": isFieldsByIdRemoved_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaishowhumansupervisoravatarrelayprovider": shouldShowHumanSupervisor_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninresolutionstrikethoughenabledrelayprovider": isNinStrikethroughResolutionUpdateEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcgoalsssrsmartcardrelayprovider": isPlaceholderDataEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider": isJiraConfluencePageContentEnabled_provider
    }
  }
};
})();

(node as any).hash = "eb9611f7c3632bd87bdb160381b49249";

export default node;
